import { gql } from "@apollo/client";

export const GetPos = gql`
  query GetPos(
    $token: String!
    $queryType: PoQueryType!
    $start_date: Time!
    $end_date: Time!
    $customerId: ID!
    $finYrId: ID!
    $after: Cursor
    $orderBy: AtsPoMstOrder
    $name: String
  ) {
    GetPos(
      token: $token
      queryType: $queryType
      start_date: $start_date
      end_date: $end_date
      customerId: $customerId
      finYrId: $finYrId
      after: $after
      orderBy: $orderBy
      where: { or: [{ poNo: $name }] }
    ) {
      edges {
        node {
          id
          poNo
          poDate
          wrkStartDate
          wrkCloseDate
          raisedByUserID
          itemQty
          totalQty
          totalRate
          totalOther
          totalTaxable
          totalTax
          totalDelvChrg
          totalInstChrg
          totalValue
          remarks
          inProgress
          completed
          customerID
          finYrID
          ldgrID
          ldgr {
            desc
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
